import React from 'react';

/* Common */
import { Button } from 'js/components/atoms';

/* Symbols */
import buttonIcon from 'symbols/arrow.svg';

export default function ConversionFlowSubmit({
    flow,
    handleClose = () => { },
    theme = 'callout',
    text = flow?.form?.buttonLabel,
    className = 'mt-1 mt-xl-0',
    type = 'submit',
    icon = buttonIcon,
    ...passProps
}) {
    const activeStep = flow?.steps.find((step) => step.active);

    return (
        <Button
            className={className}
            theme={theme}
            text={text}
            type={type}
            {...passProps}
            icon={icon}
            onClick={(e) => {
                if (activeStep?.last) {
                    e.preventDefault();
                    handleClose();
                }
            }}
        />
    )
}
